import { IAttributeOption } from 'features/RiskManagement/Assessments/Scenarios/whatIfScenarioSlice'

export const removeDuplicateAttributesOptions = (
  scenarioAttributes: IAttributeOption[]
) => {
  const uniqueScenarioAttributes: Array<IAttributeOption> = []

  const filteredScenarioAttributes = scenarioAttributes.filter((attribute) => {
    const isDuplicate = uniqueScenarioAttributes.find(
      (attr) => attr.code === attribute.code
    )

    if (!isDuplicate) {
      uniqueScenarioAttributes.push(attribute)

      return true
    }

    return false
  })

  return filteredScenarioAttributes
}
